// extracted by mini-css-extract-plugin
export default {"project-list":"ProjectList_project-list__muavQ","visible":"ProjectList_visible__H2hIb","project-card-link":"ProjectList_project-card-link__X+lxC"};